import { tracerAPIUrl } from "@/environment";

export default {
  // A worker streams NDJSON from the tracer and builds the chosen format off the main
  // thread, so the tab stays responsive. onProgress receives { phase, done, total }
  // messages across download + build.
  exportAuditLogs(start, end, format = "xlsx", onProgress) {
    const url = new URL(`${tracerAPIUrl}/auditlogs/export`);
    url.searchParams.set("start", start);
    url.searchParams.set("end", end);

    return new Promise((resolve, reject) => {
      const worker = new Worker(new URL("./auditExport.worker.js", import.meta.url), {
        type: "module",
      });
      worker.onmessage = ({ data }) => {
        if (data.type === "progress") {
          onProgress?.(data);
        } else if (data.type === "done") {
          worker.terminate();
          resolve(data.blob);
        } else if (data.type === "error") {
          worker.terminate();
          reject(new Error(data.message));
        }
      };
      worker.onerror = (event) => {
        worker.terminate();
        reject(new Error(event.message || "Export worker failed"));
      };
      worker.postMessage({ url: url.toString(), format });
    });
  },
};
